
import Vue from "vue";
import { mapState } from "vuex";
import { UI } from "@/store/ui";
export default Vue.extend({
  computed: {
    ...mapState({
      toasts: state => (state as any).ui.toasts
    })
  },
  methods: {
    onToastInput(value: any, id: string) {
      if (!value) {
        this.$store.dispatch(UI.NS(UI.ACTIONS.REMOVE_TOAST_BY_ID), id);
      }
    }
  }
});
